import { render, staticRenderFns } from "./BigChallengeDetail.vue?vue&type=template&id=1cdfd660&scoped=true"
import script from "./BigChallengeDetail.vue?vue&type=script&lang=js"
export * from "./BigChallengeDetail.vue?vue&type=script&lang=js"
import style0 from "./BigChallengeDetail.vue?vue&type=style&index=0&id=1cdfd660&prod&scoped=true&lang=css"
import style1 from "./BigChallengeDetail.vue?vue&type=style&index=1&id=1cdfd660&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdfd660",
  null
  
)

export default component.exports